import { render } from "./ViewChallengeRequests.vue?vue&type=template&id=11ad35fa&scoped=true"
import script from "./ViewChallengeRequests.vue?vue&type=script&lang=js"
export * from "./ViewChallengeRequests.vue?vue&type=script&lang=js"

import "@/css/views/view-challange-requests.css?vue&type=style&index=0&id=11ad35fa&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ad35fa"]])

export default __exports__